



















import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganization,
} from '../../utils/OversightUtils';
import cloneDeep from 'lodash.clonedeep';
import OversightForm from '@/components/oversight/OversightForm.vue';
export default mixins().extend({
  components: {
    OversightForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    pristine?: Partial<OversightOrganization>;
    oversight?: Partial<OversightOrganization>;
  } {
    return {
      pristine: undefined,
      oversight: undefined,
    };
  },
  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([
          OversightUtils.api.instance.get(this.id),
        ]);
        this.pristine = resp[0];
        this.oversight = cloneDeep(this.pristine);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
  methods: {
    async submit() {
      if (this.oversight) {
        try {
          this.$alert.hide('submit');
          await OversightUtils.api.instance.update(this.oversight);
          this.pristine = cloneDeep(this.oversight);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.oversightOrganization.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
